import { FC, ReactNode } from 'react'
import cn from 'classnames'
import { formatUSCurrency } from 'helpers/formatHelpers'
import styles from 'components/features/rewards/rewardPage/ChartPresetHeading/ChartPresetHeading.styl'

type ChartPresetHeadingProps = {
  headerLabel: ReactNode
  header?: ReactNode
  cashLabel: ReactNode
  cash: number
  cryptoLabel: ReactNode
  crypto: number
}

export const ChartPresetHeading: FC<ChartPresetHeadingProps> = ({
  headerLabel,
  header,
  cashLabel,
  cash,
  cryptoLabel,
  crypto,
}) => {

  return (
    <>
      <h4 className={ styles.title }>
        { headerLabel }
      </h4>
      { header && (
        <p className={ styles.balance }>
          { header }
        </p>
      )}
      <div className={ styles.balancesWrapper }>
        <div className={ styles.balanceColumn }>
          <h6 className={ styles.balanceName }>
            <span className={ cn(styles.balanceHeadPoint, styles.usd) } />
            { cashLabel }
          </h6>
          <span className={ styles.balanceSum }>{ formatUSCurrency(cash, 'penny') }</span>
        </div>

        <div className={ styles.balanceColumn }>
          <h6 className={ styles.balanceName }>
            <span className={ cn(styles.balanceHeadPoint, styles.crypto) } />
            { cryptoLabel }
          </h6>
          <span className={ styles.balanceSum }>{ formatUSCurrency(crypto, 'penny') }</span>
        </div>
      </div>
    </>
  )
}
